import React from 'react';
import '../svg.css';


const Plumbing_Fixtures = props => {
    const { fill } = props;
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
            height="36px"
            width="36px"
            className='svg'
        >
            <g id="Logo"><rect id="frame" className="plumbing_fixtures-1" width="36" height="36" rx="10" /></g><path className="plumbing_fixtures-2" d="M12.72,11.51a2.35,2.35,0,1,1,4.69,0v1.17H15.07v1.17h5.86V12.68H18.59V11.51a2.35,2.35,0,1,1,4.69,0v1.76h1.17V11.51A3.52,3.52,0,0,0,18,9.57a3.52,3.52,0,0,0-6.45,1.94v1.76h1.17Z" /><path className="plumbing_fixtures-3" d="M9.2,15V16.2h1.2a7.62,7.62,0,0,0,15.2,0h1.2V15Z" /><path className="plumbing_fixtures-2" d="M22.11,24.84A8.58,8.58,0,0,0,22,23.49a8.77,8.77,0,0,1-8,0,8.58,8.58,0,0,0-.12,1.35v2H12.72V28H23.28V26.84H22.11Z" /></svg>
    )
};

export default Plumbing_Fixtures;
